import { Box, Chip, Typography } from "@mui/joy";

import type { VarianceSummaryData } from "./utils";
import { formatDifferenceLabel } from "./utils";

type VarianceSummaryProps = {
    summary: VarianceSummaryData;
};

export function VarianceSummary({ summary }: VarianceSummaryProps) {
    const { totalCount, varianceCount, largestVariance } = summary;
    const allMatch = varianceCount === 0;

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "flex-start", sm: "center" },
                justifyContent: "space-between",
                gap: 1.5,
                p: 1.5,
                py: 1,
                borderRadius: "4px",

                bgcolor: allMatch ? "success.softBg" : "warning.softBg",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    flexWrap: "wrap",
                }}
            >
                <Chip
                    size="sm"
                    variant="soft"
                    color={allMatch ? "success" : "warning"}
                >
                    {allMatch
                        ? "All match"
                        : `${varianceCount} of ${totalCount} differ`}
                </Chip>
                <Typography
                    level="body-sm"
                    color={allMatch ? "success" : "warning"}
                >
                    {allMatch
                        ? "All measurements match calculated values."
                        : "Review rows with a variance before completing."}
                </Typography>
            </Box>

            {!allMatch && largestVariance && (
                <Typography
                    level="body-sm"
                    sx={{ color: "text.secondary", whiteSpace: "nowrap" }}
                >
                    Largest variance:{" "}
                    <Typography component="span" level="title-sm">
                        {largestVariance.label},
                        {formatDifferenceLabel(
                            largestVariance.difference,
                            true,
                        )}{" "}
                        {largestVariance.unit}
                    </Typography>
                </Typography>
            )}

            {allMatch && (
                <Typography level="body-sm" sx={{ color: "text.secondary" }}>
                    {totalCount} measurements reviewed
                </Typography>
            )}
        </Box>
    );
}
